var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasComponent)?_c(_vm.id,{tag:"component"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }